import { createContext, useContext, type ReactNode } from "react";
import type { PublicacoesGateway } from "../infrastructure/publicacoes.gateway";

const Ctx = createContext<PublicacoesGateway | null>(null);

export function ProvedorDePublicacoes({
  gateway,
  children,
}: {
  readonly gateway: PublicacoesGateway;
  readonly children: ReactNode;
}) {
  return <Ctx.Provider value={gateway}>{children}</Ctx.Provider>;
}

export function usePublicacoesGateway(): PublicacoesGateway {
  const g = useContext(Ctx);
  if (!g) throw new Error("ProvedorDePublicacoes ausente");
  return g;
}

/** Null fora do provedor (testes de páginas sem módulo de publicações). */
export function usePublicacoesGatewayOpcional(): PublicacoesGateway | null {
  return useContext(Ctx);
}
